import { createFeature, createReducer, on } from '@ngrx/store';

import { loadBFPData, loadBFPDataFailure, loadBFPDataSuccess, resetBFPData } from './bfp.actions';
import { BfpState, CropFieldNutrientCalculations, CropFieldNutrientCalculationsResponse } from '../shared/models/models';
import { cropYearChanged } from '../../store/actions';

const initialState: BfpState = {
  cropFieldNutrientCalculation: [],
  loadStatus: 'idle',
  customerId: null,
};

export const bfpFeature = createFeature({
  name: 'bfp',
  reducer: createReducer(initialState,

    on(cropYearChanged, (): BfpState => initialState),

    on(loadBFPData, (state): BfpState => ({ ...state, loadStatus: 'loading' })),
    on(loadBFPDataFailure, (state): BfpState => ({ ...state, loadStatus: 'error' })),
    on(resetBFPData, (): BfpState => initialState),

    on(loadBFPDataSuccess, (state, action): BfpState => ({
      ...state,
      cropFieldNutrientCalculation: action.payload.data.map((d) => extractCropFieldNutrientCalculations(d)),
      loadStatus: 'loaded',
      customerId: action.payload.customerId,
    })),
  ),
});

export const extractCropFieldNutrientCalculations = (data: CropFieldNutrientCalculationsResponse): CropFieldNutrientCalculations => ({
  id: data.id,
  name: data.name,
  areaInHectares: data.areaInHectares,
  n: data.n as 1 | 2 | 3,
  latestSampleDate: data.sampleDate,
  nutrientCalculation: {
    k: data.nutrientCalculation ? {
      recKgha: data.nutrientCalculation?.kRecKgha ?? null,
      adviceTxt: data.nutrientCalculation?.kAdviceTxt ?? null,
      color: null,
    } : undefined,
    n: data.nutrientCalculation ? {
      recKgha: data.nutrientCalculation?.nRecKgha ?? null,
      adviceTxt: data.nutrientCalculation?.nAdviceTxt ?? null,
      color: null,
    } : undefined,
    mn: data.nutrientCalculation ? {
      adviceTxt: data.nutrientCalculation?.mnAdviceTxt ?? null,
      color: null,
    } : undefined,
    mg: data.nutrientCalculation ? {
      recKgha: data.nutrientCalculation?.mgRecKgha ?? null,
      adviceTxt: data.nutrientCalculation?.mgAdviceTxt ?? null,
      color: null,
    } : undefined,
    b: data.nutrientCalculation ? {
      adviceTxt: data.nutrientCalculation?.bAdviceTxt ?? null,
      color: null,
    } : undefined,
    s: data.nutrientCalculation ? {
      adviceTxt: data.nutrientCalculation?.so3AdviceTxt ?? null,
      color: null,
    } : undefined,
  },
});

export const { selectCropFieldNutrientCalculation, selectLoadStatus, selectCustomerId } = bfpFeature;
